//Types
import {
  CLOSE_BONUS_TOAST,
  DELETE_BONUS,
  GET_BONUS,
  INSERT_BONUS,
  OPEN_BONUS_TOAST,
  UPDATE_BONUS,
  UPDATE_BONUS_STATUS,
  OPEN_BONUS_DRM_DIALOG,
  CLOSE_BONUS_DRM_DIALOG,
} from "./bonusContent.type";

import uploadFileTypes from "./bonusContent.type";
import { modifyFiles } from "../../util/ModifyFiles";

//Define initialState
const initialState = {
  bonus: [],
  drmDialog: false,
  drmDialogData: null,
  toast: false,
  toastData: null,
  actionFor: null,
};

const bonusContentReducer = (state = initialState, action) => {
  switch (action.type) {
    //Get Bonus Content
    case GET_BONUS:
      return {
        ...state,
        bonus: action.payload,
      };

    //Insert Bonus Content
    case INSERT_BONUS:
      const data = [...state.bonus];
      data.unshift(action.payload);
      return {
        ...state,
        bonus: data,
      };

    //Update Bonus Content
    case UPDATE_BONUS:
      return {
        ...state,
        bonus: state.bonus.map((bonus) =>
          bonus._id === action.payload.id ? action.payload.data : bonus
        ),
      };

    //Update Bonus Content Status Only (plus the target status when the backend reports it)
    case UPDATE_BONUS_STATUS:
      return {
        ...state,
        bonus: state.bonus.map((bonus) =>
          bonus._id === action.payload.bonusId
            ? {
                ...bonus,
                status: action.payload.status,
                ...(action.payload.statusAfterTranscode !== undefined && {
                  statusAfterTranscode: action.payload.statusAfterTranscode,
                }),
              }
            : bonus
        ),
      };

    //Delete Bonus Content
    case DELETE_BONUS:
      return {
        ...state,
        bonus: state.bonus.filter((bonus) => bonus._id !== action.payload),
      };

    //Open DRM Dialog
    case OPEN_BONUS_DRM_DIALOG:
      return {
        ...state,
        drmDialog: true,
        drmDialogData: action.payload || null,
      };

    //Close DRM Dialog
    case CLOSE_BONUS_DRM_DIALOG:
      return {
        ...state,
        drmDialog: false,
        drmDialogData: null,
      };

    //Open and Close Toast
    case OPEN_BONUS_TOAST:
      return {
        ...state,
        toast: true,
        toastData: action.payload.data || null,
        actionFor: action.payload.for || null,
      };

    case CLOSE_BONUS_TOAST:
      return {
        ...state,
        toast: false,
        toastData: null,
        actionFor: null,
      };

    case uploadFileTypes.SET_UPLOAD_FILE:
      return {
        ...state,
        fileProgress: {
          ...state.fileProgress,
          ...modifyFiles(state.fileProgress, action.payload),
        },
      };
    case uploadFileTypes.SET_UPLOAD_PROGRESS:
      return {
        ...state,
        fileProgress: {
          ...state.fileProgress,
          [action.payload.id]: {
            ...state.fileProgress[action.payload.id],
            progress: action.payload.progress,
          },
        },
      };

    case uploadFileTypes.SUCCESS_UPLOAD_FILE:
      return {
        ...state,
        fileProgress: {
          ...state.fileProgress,
          [action.payload]: {
            ...state.fileProgress[action.payload],
            status: 1,
          },
        },
      };

    case uploadFileTypes.FAILURE_UPLOAD_FILE:
    default:
      return state;
  }
};

export default bonusContentReducer;
